<template>
  <Bread-crumb page="Beranda"></Bread-crumb>
  <!--content-area-sga-->
  <div class="container content-area">
    <div v-if="fromlogout" class="alert alert-warning" role="alert">
      Anda sudah keluar dari aplikasi, silahkan <router-link to="/login">login</router-link> kembali jika ingin melanjutkan.
    </div>
    <div class="row">
      <div class="col-12">
        <h3 class="judul-seksi-sga">Admin Dashboard</h3>
        <hr>
        <div class="form-general">
          <LoadSpinner v-if="loading"></LoadSpinner>
          <div v-else class="row bg-light rounded mb-3 p-3" v-for="(dt,idx) in dataKabar" :key="idx">
            <div class="col-12 text-center">
              <p v-html="dt.text"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import DashboardServices from "@/services/dashboard.services";
import LoadSpinner from "@/components/LoadSpinner";
export default {
  name: "AdminIndex",
  components:{LoadSpinner, BreadCrumb},
  props:{
    fromlogout: Boolean
  },
  data: () => ({
    dataKabar:[],
    loading: false,
    message:''
  }),
  methods:{
    getArticle(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = {};
      let path = '/gemala/info/getArticle';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.dataKabar = this.response.data;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
  },
  mounted() {
    localStorage.removeItem('tipepsb');
    this.getArticle();
  }
}
</script>

<style scoped>

</style>